(function () {
  'use strict';

  var PHONE_RAW = '2153269845';
  var PHONE_DISPLAY = '215-326-9845';
  var BUTTON_LABEL = 'Call for Pricing';
  var BUTTON_CLASS = 'snize-call-for-price-btn';
  var WRAPPER_CLASS = 'snize-call-for-price-action';
  var GRID_SELECTOR = '#snize-search-results-grid-mode, .snize-search-results-grid-mode';
  var POLL_MS = 500;
  var pollTimer = null;
  var searchaniseJqueryBound = false;
  var processRetryDelays = [0, 50, 150, 350, 750, 1500];

  function normalizePriceText(text) {
    return (text || '').replace(/\s+/g, '').toLowerCase();
  }

  function isMeaningfulPriceText(text) {
    var normalized = normalizePriceText(text);
    if (!normalized) {
      return false;
    }

    if (
      normalized.indexOf('callforprice') !== -1 ||
      normalized.indexOf('callforpricing') !== -1 ||
      normalized.indexOf('contactus') !== -1 ||
      normalized.indexOf('requestquote') !== -1
    ) {
      return false;
    }

    var amount = parseFloat(normalized.replace(/[^0-9.]/g, ''));
    if (isNaN(amount) || amount <= 0) {
      return false;
    }

    // Matches theme logic for call-for-pricing variants (price > 99900000 cents).
    if (amount >= 999000) {
      return false;
    }

    return true;
  }

  function isVisiblePriceElement(el) {
    if (!el) {
      return false;
    }

    var node = el;
    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }
      node = node.parentElement;
    }

    return true;
  }

  function getPriceElements(li) {
    return li.querySelectorAll(
      '.snize-price-list .snize-price, .snize-price-list .snize-price-with-discount, .snize-price-list .snize-compare-price, .snize-price-list .snize-compare-price-right, .snize-price'
    );
  }

  function hasAnyPrice(li) {
    var priceElements = getPriceElements(li);

    for (var i = 0; i < priceElements.length; i++) {
      var priceEl = priceElements[i];
      if (isVisiblePriceElement(priceEl) && isMeaningfulPriceText(priceEl.textContent)) {
        return true;
      }
    }

    var priceList = li.querySelector('.snize-price-list');
    if (priceList && isVisiblePriceElement(priceList) && isMeaningfulPriceText(priceList.textContent)) {
      return true;
    }

    return false;
  }

  function isMobileDevice() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function revealPhoneNumber(button) {
    button.textContent = PHONE_DISPLAY;
    button.classList.add('is-revealed');
    button.setAttribute('aria-label', 'Phone number ' + PHONE_DISPLAY);
  }

  function resetButtonLabel(button) {
    button.textContent = BUTTON_LABEL;
    button.classList.remove('is-revealed');
    button.setAttribute('aria-label', BUTTON_LABEL);
  }

  function bindButtonInteractions(button) {
    if (button.dataset.interactionsBound === 'true') {
      return;
    }

    button.dataset.interactionsBound = 'true';

    button.addEventListener('mouseenter', function () {
      if (!isMobileDevice()) {
        revealPhoneNumber(button);
      }
    });

    button.addEventListener('mouseleave', function () {
      if (!isMobileDevice()) {
        resetButtonLabel(button);
      }
    });
  }

  function setupClickHandler() {
    document.addEventListener(
      'click',
      function (e) {
        var button = e.target.closest('.' + BUTTON_CLASS);
        if (!button) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (isMobileDevice()) {
          window.location.href = 'tel:' + PHONE_RAW;
        }
      },
      true
    );
  }

  function getInsertAnchor(li) {
    return (
      li.querySelector('.snize-overhidden') ||
      li.querySelector('.snize-description') ||
      li.querySelector('.snize-title') ||
      li.querySelector('a.snize-view-link') ||
      li
    );
  }

  function removeCallForPriceButton(li) {
    var wrapper = li.querySelector('.' + WRAPPER_CLASS);
    if (wrapper) {
      wrapper.remove();
      return;
    }

    var button = li.querySelector('.' + BUTTON_CLASS);
    if (button) {
      button.remove();
    }
  }

  function addCallForPriceButton(li) {
    if (li.querySelector('.' + BUTTON_CLASS)) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = BUTTON_CLASS + ' button button-not-animation';
    button.textContent = BUTTON_LABEL;
    button.setAttribute('aria-label', BUTTON_LABEL);

    wrapper.appendChild(button);
    bindButtonInteractions(button);

    var overhidden = li.querySelector('.snize-overhidden');
    if (overhidden) {
      overhidden.appendChild(wrapper);
      return;
    }

    var anchor = getInsertAnchor(li);
    if (!anchor || anchor === li) {
      li.appendChild(wrapper);
      return;
    }

    anchor.insertAdjacentElement('afterend', wrapper);
  }

  function processProductLi(li) {
    if (!li.classList.contains('snize-product')) {
      return;
    }

    if (hasAnyPrice(li)) {
      removeCallForPriceButton(li);
      return;
    }

    addCallForPriceButton(li);
  }

  function getProductItems() {
    var snizeResults = document.getElementById('snize_results');
    if (!snizeResults) {
      return null;
    }

    var grid = document.querySelector(GRID_SELECTOR);
    if (grid) {
      var gridProducts = grid.querySelectorAll('li.snize-product');
      if (gridProducts.length) {
        return gridProducts;
      }
    }

    return snizeResults.querySelectorAll('li.snize-product');
  }

  function processGrid() {
    var products = getProductItems();
    if (!products || !products.length) {
      return false;
    }

    products.forEach(processProductLi);
    return true;
  }

  function scheduleProcess() {
    processRetryDelays.forEach(function (delay) {
      setTimeout(processGrid, delay);
    });
  }

  function bindSearchaniseJquery() {
    if (searchaniseJqueryBound || !window.Searchanise || !window.Searchanise.$) {
      return;
    }

    searchaniseJqueryBound = true;
    window.Searchanise.$(document).on('Searchanise.ResultsUpdated', scheduleProcess);
  }

  function setupPaginationListener() {
    document.addEventListener(
      'click',
      function (e) {
        if (
          e.target.closest(
            '.snize-pagination a, .snize-pagination button, .snize-show-more-button, .snize-pagination-page'
          )
        ) {
          scheduleProcess();
        }
      },
      true
    );
  }

  function startPolling() {
    if (pollTimer) {
      return;
    }

    pollTimer = setInterval(function () {
      if (!document.getElementById('snize_results')) {
        clearInterval(pollTimer);
        pollTimer = null;
        return;
      }

      processGrid();
    }, POLL_MS);
  }

  function setupMutationObserver() {
    var debounceTimer = null;

    function onSnizeMutate() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(scheduleProcess, 100);
    }

    var observer = new MutationObserver(onSnizeMutate);
    var snizeRoot = document.getElementById('snize_results');

    if (snizeRoot) {
      observer.observe(snizeRoot, { childList: true, subtree: true });
      return;
    }

    var bodyObserver = new MutationObserver(function (mutations, bodyObs) {
      snizeRoot = document.getElementById('snize_results');
      if (!snizeRoot) {
        return;
      }

      bodyObs.disconnect();
      observer.observe(snizeRoot, { childList: true, subtree: true });
      scheduleProcess();
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function setupSearchaniseHooks() {
    document.addEventListener('Searchanise.ResultsUpdated', scheduleProcess);
    document.addEventListener('Searchanise.Loaded', function () {
      bindSearchaniseJquery();
      scheduleProcess();
    });

    bindSearchaniseJquery();
  }

  function init() {
    setupClickHandler();
    setupPaginationListener();
    setupSearchaniseHooks();
    setupMutationObserver();
    scheduleProcess();
    startPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
